import { gql } from '@apollo/client';

export const CREATE_ROOM = gql`
  mutation CreateRoom($record: CreateRoomInput!) {
    schedule {
      createRoom(record: $record) {
        ok
        error {
          message
          code
        }
        resultId
        result {
          id
          name
          organization {
            id
            name
          }
          reservationModes {
            reservationMode {
              id
              name
            }
            parallelSlotsNumber
          }
        }
      }
    }
  }
`;
